// The Rhythm Report — per-genre color system (accent layer on the XXL canvas).
// Mirrors the gradient families used by the generated art tiles.
export const GENRE_COLORS = {
  "Hip-Hop": { hex: "#FF2A6D", bg: "rgba(255,0,85,0.12)", glow: "rgba(255,0,85,0.40)" },
  "R&B": { hex: "#C084FC", bg: "rgba(168,85,247,0.12)", glow: "rgba(168,85,247,0.40)" },
  "Pop": { hex: "#F472B6", bg: "rgba(236,72,153,0.12)", glow: "rgba(236,72,153,0.40)" },
  "Rock": { hex: "#FBBF24", bg: "rgba(245,158,11,0.12)", glow: "rgba(245,158,11,0.40)" },
  "Country": { hex: "#FB923C", bg: "rgba(249,115,22,0.12)", glow: "rgba(249,115,22,0.40)" },
  "Dance": { hex: "#22D3EE", bg: "rgba(6,182,212,0.12)", glow: "rgba(6,182,212,0.40)" },
  "Alternative": { hex: "#34D399", bg: "rgba(16,185,129,0.12)", glow: "rgba(16,185,129,0.40)" },
  "Global": { hex: "#60A5FA", bg: "rgba(59,130,246,0.12)", glow: "rgba(59,130,246,0.40)" },
};

const MATCHES = [
  ["hip-hop", "Hip-Hop"],
  ["hip hop", "Hip-Hop"],
  ["rap", "Hip-Hop"],
  ["r&b", "R&B"],
  ["country", "Country"],
  ["pop", "Pop"],
  ["dance", "Dance"],
  ["soul", "Alternative"],
  ["jazz", "Alternative"],
  ["indie", "Rock"],
  ["rock", "Rock"],
  ["alternative", "Alternative"],
  ["global", "Global"],
];

export function genreColor(genre) {
  const s = (genre || "").toLowerCase();
  const hit = MATCHES.find(([k]) => s.includes(k));
  return hit ? { key: hit[1], ...GENRE_COLORS[hit[1]] } : null;
}
